<template>
  <section class="my-8 md:my-12">
    <div class="px-12 lg:px-16 xl:px-24">
      <div class="page-container">
        <Search class="w-full"
                label-classes="hidden"
                input-group-classes="md:!w-full !mb-14 relative"
                placeholder="Search Articles"
                input-classes="!w-full !bg-transparent !rounded-md !border !border-primary/20 !px-6 !py-6"
                submit-btn-label=""
                submit-btn-classes="!bg-transparent !border-none !shadow-none absolute right-0 bottom-0 top-0"
                :show-search-icon="true"
                @search="handleSearch"
        />
        <nav class="resources-categories relative after:content-['']
      after:absolute after:right-0 after:top-0 after:bottom-0 after:w-8 after:bg-gradient-to-r from-transparent to-white">
          <ul class="flex gap-4 md:gap-8 text-grey-300 mb-14 border-b border-grey pb-4 whitespace-nowrap pr-8
      overflow-x-scroll">
            <li class="!mb-0">
              <NuxtLink :to="{path: route.path}"  class="px-2 pb-4 border-b-2" :class="!route.query.category ? 'text-primary font-medium border-primary' : 'border-transparent'">
                View All
              </NuxtLink>
            </li>
            <li v-for="category in categories" class="!mb-0">
              <NuxtLink :to="{query: {'category' : category.slug}}"
                        class="px-2 pb-4 border-b-2"
                        :class="route.query.category === category.slug ? 'text-primary font-medium  border-primary' : 'border-transparent'">
                {{ category.name }}
              </NuxtLink>
            </li>
          </ul>
        </nav>
        <ResourcesGrid :active-category="activeCategory"
                       :refresh-data="shouldRefresh"
                       :is-refreshing="isRefreshing"
                       :search-query="searchQuery"
                       @refresh-started="handleRefreshStarted"
                       @refresh-completed="handleRefreshCompleted"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Ref, ref } from "vue";
import { useRoute } from "vue-router";
import { getCategoriesQuery } from "~/graphql/queries/getCategories";
import ResourcesGrid from "~/components/pages/blocks/ResourcesGrid.vue";

interface Category {
  slug: string;
  name: string;
  description: string;
  categoryId: string;
}

const route = useRoute();
const categories: Ref<Category[]> = ref([]);
const activeCategory: Ref = ref("");
const shouldRefresh = ref(false);
const searchQuery = ref('');
const isRefreshing = ref(false);

const query = getCategoriesQuery();

const { data } = await useAsyncQuery(query);

const getActiveCategoryFromSlug = (slug: string) => {
  return categories.value.find((category) => category.slug === slug);
}

if (data.value.categories.nodes) {
  categories.value = data.value.categories.nodes as Category[];
}

if (route.query.category) {
  const foundCategory = getActiveCategoryFromSlug(route.query.category);
  if (foundCategory) {
    activeCategory.value = foundCategory;
  }
}

watch(() => route.query.category, (newCategorySlug) => {
  if (typeof newCategorySlug === 'undefined') {
    activeCategory.value = '';
    shouldRefresh.value = true;
  } else {
    const foundCategory = getActiveCategoryFromSlug(newCategorySlug);

    if (foundCategory) {
      activeCategory.value = foundCategory;
      shouldRefresh.value = true;
    }
  }
});

const handleRefreshStarted = () => {
  isRefreshing.value = true;
}

const handleRefreshCompleted = () => {
  isRefreshing.value = false;
  shouldRefresh.value = false;
}

const handleSearch = (search: string) => {
  searchQuery.value = search;
}
</script>

<style scoped>

</style>
